import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader, CardText } from 'material-ui';
import FileIcon from 'material-ui/svg-icons/editor/attach-file';
import ContractListIcon from 'material-ui/svg-icons/action/chrome-reader-mode';
import TemplateIcon from 'material-ui/svg-icons/action/description';
import ExternalFiles from './external-files';
import RespondedContractList from './responded-contract-list';
import RateConversion from '../../../dummy-account/rate-conversion';


const propTypes = {
  rateConversionStatus: PropTypes.string,
  respondedContracts: PropTypes.array,
  files: PropTypes.array,
};

class CRBuyerViewMainContent extends Component {

  render() {
    const {
      rateConversionStatus,
      respondedContracts = [],
      files = [],
    } = this.props;
    const converting = rateConversionStatus !== 'Awaiting Supplier Rates'
      && rateConversionStatus !== 'Conversion Complete' && rateConversionStatus !== 'Signed';
    return (
      <div>
        <Card>
          <CardHeader
            title={(
              <div className="flex-center">
                <FileIcon/>&nbsp;&nbsp;
                Files ({files.length})
              </div>
            )}
            titleStyle={{ fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' }}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable style={{ padding: '1em 2em' }}>
            <ExternalFiles/>
          </CardText>
        </Card>
        <Card
          style={{ marginTop: '1em' }}
          initiallyExpanded={Boolean(respondedContracts.length)}
        >
          <CardHeader
            title={(
              <div className="flex-center">
                <ContractListIcon/>&nbsp;&nbsp;
                TourConnect Format Rate Contracts ({respondedContracts.length})
              </div>
            )}
            titleStyle={{ fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' }}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable style={{ padding: '1em 2em' }}>
            <RespondedContractList/>
          </CardText>
        </Card>
        <Card
          style={{ marginTop: '1em' }}
          initiallyExpanded={converting}
        >
          <CardHeader
            title={(
              <div className="flex-center">
                <TemplateIcon/>&nbsp;&nbsp;
                Rate Conversion
              </div>
            )}
            titleStyle={{ fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' }}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable style={{ padding: '1em 2em' }}>
            <RateConversion/>
          </CardText>
        </Card>
      </div>
    );
  }
}

CRBuyerViewMainContent.propTypes = propTypes;

export default connect(({ contracting }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    rateConversionStatus: rightSideContent.rateConversionStatus,
    respondedContracts: leftNav.respondedContracts,
    files: leftNav.files,
  };
})(CRBuyerViewMainContent);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/contract-request-buyer-view/main-content.jsx